import React from "react";
import Wdata from "../Data/Wdata";
function World() {
  return (
    <div>
        <div className="row my-3">
          <div className="col-lg-12 pb-2">
            <div className="border pb-3">
              <h2 className="pt-3 me-2 ps-4"><span className="a">WORLD NEWS</span></h2>
              <div className="row pt-2 px-3">
                {Wdata.slice(3, 4).map((a) => (
                  <>
                    <div className="col-lg-6 mt-3">
                      <div className="card">
                        <img className="w-100" src={a.img} />
                        <div className="card-body">
                          <a href="/world">
                            <h5 className="text-dark fw-semibold">{a.title}</h5>
                          </a>
                          <div className="d-flex text-secondary">
                            <i class="bi bi-clock-fill fs-6"></i>
                            <p className=" ps-2">November 16 , 2017</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="p-2 mb-2">
                        {Wdata.slice(0, 3).map((a) => (
                          <>
                            <div className="d-flex border my-2">
                              <div className="flex-shrink-0">
                                <img
                                  className="object-fit-cover"
                                  width={110}
                                  height={120}
                                  src={a.img}
                                />
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <a href="/world">
                                  <p className="text-dark pe-2">
                                    {a.description}
                                  </p>
                                </a>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default World;
